import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useEditMode } from '../../../shared/hooks/useEditMode';
import { useProjectElementListStore } from '../../../shared/store/projectElementStore';
import { SelectType, DisplayAlignment, DisplaySize, ImageStyle, normalizePEInfoType, PEInfoType, usesWorkDuration } from '../../../shared/enum/EnumRepository';
import { PEWorkData } from '../../../shared/dto/EntityRepository';
import SelectBox from '../../../shared/component/SelectBox';
import { useImageStyleJudge } from '../../../shared/hooks/useImageStyleJudge';
import WorkInfoMobile from './WorkInfoMobile';
import WorkImgInPeMobile from './WorkImgInPeMobile';
import WorkVideoInPeMobile from './WorkVideoInPeMobile';
import { PEIndicator } from '../Work';

export { PEIndicator };




export interface WorkMobileProps {
  peId: string;
  alignment: DisplayAlignment;
  displaySize: DisplaySize;
  infoType?: PEInfoType;
  data: PEWorkData;
  priority: boolean;
}

const WorkMobile: React.FC<WorkMobileProps> = ({ peId, alignment, displaySize, infoType, data, priority }) => {
  const { isEditMode } = useEditMode();
  const handleDisplaySizeChange = useProjectElementListStore((s) => s.updateDisplaySize);
  const handleInfoTypeChange = useProjectElementListStore((s) => s.updateInfoType);
  const { judgeImageStyle } = useImageStyleJudge();
  const imageStyle = useMemo(() => judgeImageStyle(data.uploadFile?.width / data.uploadFile?.height), [data.uploadFile?.width, data.uploadFile?.height]);
  const effectiveInfoType = normalizePEInfoType(infoType);


  return (
    <PEImgContentWrapper>
      {isEditMode &&
        <PEHeader>
          <SelectBoxContainer>
            <SelectBoxWrapper>
              <SelectBox
                value={displaySize || DisplaySize.BIG}
                selectType={SelectType.WORK_SIZE}
                handleChange={(value) => handleDisplaySizeChange(peId, value)}
                direction={false} />
            </SelectBoxWrapper>
            <SelectBoxWrapper>
              <SelectBox
                value={effectiveInfoType}
                selectType={SelectType.PE_INFO_TYPE}
                handleChange={(value) => handleInfoTypeChange(peId, value)}
                direction={false} />
            </SelectBoxWrapper>
          </SelectBoxContainer>
          <PEIndicator peId={peId}>: Work</PEIndicator>
        </PEHeader>
      }
      <ImgContentCoreWrapper>
        <ImgWrapper>
          {usesWorkDuration(data.workType) ? (
            <WorkVideoInPeMobile
              peId={peId}
              alignment={DisplayAlignment.CENTER}
              displaySize={displaySize || DisplaySize.BIG}
              data={data}
              priority={priority}
            />
          ) : (
            <WorkImgInPeMobile
              peId={peId}
              alignment={DisplayAlignment.CENTER}
              displaySize={displaySize || DisplaySize.BIG}
              data={data}
              priority={priority}
            />
          )}
        </ImgWrapper>
        <WorkInfoMobile
          peId={peId}
          alignment={alignment || DisplayAlignment.CENTER}
          displaySize={displaySize || DisplaySize.BIG}
          imageStyle={imageStyle || ImageStyle.LANDSCAPE}
          infoType={effectiveInfoType}
          data={data} />
      </ImgContentCoreWrapper>
    </PEImgContentWrapper>
  );
};

export const PEImgContentWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PEHeader = styled.div`
  position: absolute;
  top: -24px;
  width: 100%;

  padding: 0 clamp(18px, 5vw, 24px);
  display: flex;
  justify-content: space-between;
`;

export const SelectBoxContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
`;

export const SelectBoxWrapper = styled.article`
  width: clamp(70px, 23vw, 80px);
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
`;

export const ImgContentCoreWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ImgWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

export default WorkMobile;
